import React from "react";
import { useTranslation } from "react-i18next";
import { FiArrowRight } from "react-icons/fi";
import "../styles/home.css";

/** Length of the first call, interpolated so no number lives in the dictionaries. */
export const CALL_MINUTES = 30;

const models = ["consulting", "assessment", "placement"] as const;

/** How we work #approach (spec c.7 §6; engagement models from finance.md §2). */
const Approach: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="approach" className="section" aria-labelledby="approach-heading">
      <div className="container">
        <header className="section-head">
          <p className="t-label">{t("approach.label")}</p>
          <h2 id="approach-heading">{t("approach.title")}</h2>
        </header>

        <ol className="steps">
          {models.map((key, i) => (
            <li key={key} className="step">
              <span className="step-num" aria-hidden="true">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3>{t(`approach.models.${key}.title`)}</h3>
              <p>{t(`approach.models.${key}.text`)}</p>
            </li>
          ))}
        </ol>

        <div className="approach-note">
          <p>{t("approach.note", { minutes: CALL_MINUTES })}</p>
          <a className="link-arrow" href="#contact">
            {t("approach.cta")}
            <FiArrowRight aria-hidden="true" focusable="false" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Approach;
